import { ref, computed } from 'vue'
import DataService from '@/features/data/dataService'
import Storage from './storage'

class PermissionsManager {
  static _permissions = ref([]) // réactif

  static async init() {
    PermissionsManager.insertPermissionsStyle(['see-permission-loader'])
    await PermissionsManager.loadPermissions()
    // setInterval(() => {
    //   PermissionsManager.loadPermissions()
    // }, 5000)
  }

  static async loadPermissions() {
    let permissions = []
    try {
      const userData = Storage.get('userData')
      const res = await DataService.getSingleData('permissions', {
        userId: userData?.id || '',
      })
      if (res.statusCode !== 200 || !Array.isArray(res.data)) return
      permissions = res.data
    } catch (error) {
      console.log('🚀 ~ PermissionsManager ~ loadPermissions ~ error:', error)
    }
    permissions.push('see-interface')

    // Met à jour les permissions réactives
    PermissionsManager._permissions.value = permissions

    PermissionsManager.insertPermissionsStyle(permissions)
  }

  static insertPermissionsStyle(permissions) {
    const css = PermissionsManager.generatePersmissionsCss(permissions)
    PermissionsManager.insertOrUpdateCSS(css)
  }

  static generatePersmissionsCss(permissions) {
    let css = `[permission] {display: none; --visible-display:block} [permission-click] {pointer-events: none;} [permission=none] {display: var(--visible-display);}`
    permissions.forEach(permission => {
      const escapedPermission = permission.replace(/:/g, '\\:')
      css += `[permission=${escapedPermission}] {display: var(--visible-display);} [permission-click=${escapedPermission}] {pointer-events: all;}`
    })
    return css
  }

  static insertOrUpdateCSS(cssContent) {
    let styleElement = document.getElementById('dynamic-permissions-style')

    if (!styleElement) {
      styleElement = document.createElement('style')
      styleElement.id = 'dynamic-permissions-style'
      document.head.appendChild(styleElement)
    }

    styleElement.innerHTML = cssContent
  }

  static getMainPermissions(permissions) {
    const mainPermissions = new Set()

    permissions.forEach(permission => {
      const mainPermission = permission.split(':')[0]
      mainPermissions.add(mainPermission)
    })

    return Array.from(mainPermissions)
  }

  /**
   * Retourne un computed qui réagit automatiquement
   * @param {string} permission
   */
  static has(permission) {
    return computed(() =>
      PermissionsManager._permissions.value.includes(permission),
    )
  }

  static getAllPermissions() {
    return PermissionsManager._permissions.value
  }

  /**
   * Plugin Vue: permet de faire app.use(PermissionsManager)
   */
  static install(app) {
    // accès complet
    app.config.globalProperties.$permission = PermissionsManager
  }
}

export default PermissionsManager
